import screen1 from "./screen1.jpg";
import screen2 from "./screen2.jpg";
import screen3 from "./screen3.jpg";
import screen4 from "./screen4.png";
import screen5 from "./screen5.jpg";
import screen6 from "./screen6.jpg";
import screen7 from "./screen7.jpg";
import screen8 from "./screen8.jpg";
import screen9 from "./screen9.jpg";
import screen10 from "./screen10.jpg";
import screen11 from "./screen11.jpg";
import screen12 from "./screen12.jpg";
import screen13 from "./screen13.jpg";
import screen14 from "./screen14.jpg";
import screen15 from "./screen15.jpg";

export const imgsTopicSevenActvOne = {
	screen1,
	screen2,
	screen3,
	screen4,
	screen5,
	screen6,
	screen7,
	screen8,
	screen9,
	screen10,
	screen11,
	screen12,
	screen13,
	screen14,
	screen15,
};
